export default "__VITE_ASSET__96qEwFOI__$_?nuxt_component=async&nuxt_component_name=SvgoSpotBg&nuxt_component_export=default__"